import { createFileRoute, Outlet } from "@tanstack/react-router";

/** Stories: the row, a new story, and one story's page. */
export const Route = createFileRoute("/_app/growth/stories")({
  component: Outlet,
});
